import { Component } from '@angular/core'
import { FieldType } from '@ngx-formly/core'

/**
 * @deprecated This component is deprecate in favor of Formly Input Number
 */
@Component({
  selector: 'basin-formly-textbox-with-units',
  templateUrl: './formly-textbox-with-units.component.html',
  styleUrls: [],
})
export class FormlyTextboxWithUnitsComponent extends FieldType {}
